<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useClerk } from '@clerk/vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import AuthLayout from '@/layouts/AuthLayout.vue';
import PublicLayout from '@/layouts/PublicLayout.vue';
import AdminLayout from '@/layouts/AdminLayout.vue';
import { ConfirmDialog } from '@/components';
import { useConfirmDialog } from '@/composables';
import { setTokenGetter } from '@/api/request';

const route = useRoute();
const clerk = useClerk();
const confirmDialog = useConfirmDialog();

setTokenGetter(async () => {
  try {
    return (await clerk.value?.session?.getToken()) ?? null;
  } catch {
    return null;
  }
});

const layout = computed(() => {
  const layoutName = route.meta.layout;
  if (layoutName === 'public') return PublicLayout;
  if (layoutName === 'auth') return AuthLayout;
  if (layoutName === 'admin') return AdminLayout;
  if (layoutName === 'default') return DefaultLayout;
  return PublicLayout;
});
</script>

<template>
  <component :is="layout">
    <router-view :key="route.fullPath" />
  </component>
  <ConfirmDialog ref="confirmDialog" />
</template>
